<template>
    <div class="edit">
        <div class="vcore_row">
            <div class="vcore_col--md--12">
                <NewUser />
            </div>
        </div>
        <div class="vcore_row">
            <div class="vcore_col--md--6">
                <div class="title"
                >Synchronize Database to Archive Files</div>
            </div>
        </div>
        <div class="vcore_row">
            <div class="vcore_col--md--6">
                <button
                        class="vcore_btn vcore_btn--primary md-button blue-button"
                        type="button"
                        @click="syncDatabase"
                >Sync</button>
            </div>
        </div>
    </div>
</template>

<script>
    import NewUser from "../components/NewUser";

    export default {
        name: "EditPrototype",
        components: {
            NewUser
        },
        methods: {
            syncDatabase(){
                this.$store.dispatch("synchronizeDatabase");
            }
        },
    }
</script>

<style lang="scss" scoped>
    .no-padding-left {
        padding-left: 0;
    }

    .form-prototype{
        margin-bottom: 15px;
    }

    .edit {
        margin-top: 50px;
    }

    .title {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 35px;
        text-align: left;
        color: #666666;
        padding-bottom: 15px;
    }

    .button-row {
        margin-top: 10px;
        margin-bottom: 5px;
    }

    .vcore_btn {
        float: left;
    }

    .md-button {
        font-size: 16px;
        font-weight: 600;
        padding: 10px 30px;
        min-width: 150px;
    }
</style>
